/* global axios */
import ApiClient from './ApiClient';

class EventsAPI extends ApiClient {
    constructor() {
        super('events', { accountScoped: true });
    }

    get(params = {}) {
        return axios.get(this.url, { params });
    }

    toggleActive(eventId) {
        return axios.post(`${this.url}/${eventId}/toggle_active`);
    }
}

export default new EventsAPI();
